export default {
  admin: () => import("/home/dev/uogorod-build-catalog-entry-20261105/layouts/admin.vue"),
  default: () => import("/home/dev/uogorod-build-catalog-entry-20261105/layouts/default.vue"),
  feed: () => import("/home/dev/uogorod-build-catalog-entry-20261105/layouts/feed.vue")
}